
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getKefuInfo, getUserInfo, changeFundsPassword } from '../service/getdata'
import authenticationVue from './authentication.vue'
import accountChangeVue from './accountChange.vue'
import shareQRcodeVue  from './shareQRcode.vue'
import moneyLogVue from './moneyLog.vue'
import moneyLog2Vue from './moneyLog2.vue'
import promoteVue from './promote.vue'
import unitVue from './unit.vue'
import helpCenterVue from './helpCenter.vue'
import aboutUsVue from './aboutUs.vue'
import bindPhoneVue from './bindPhone.vue'
import changeFundsPasswordVue from './changeFundsPassword.vue'
import setFundsPasswordVue from './setFundsPassword.vue'
import changePasswordVue from './changePassword.vue'
export default{
components:{
XHeader,
Toast,
authenticationVue,
accountChangeVue,
shareQRcodeVue,
promoteVue,
unitVue,
aboutUsVue,
helpCenterVue,
bindPhoneVue,
changeFundsPasswordVue,
setFundsPasswordVue,
changePasswordVue,
moneyLogVue,
moneyLog2Vue
},
data(){
return{
msg: "",
show: false,
url: "",
activeIndex: '1',
list: [], //质押列表
userInfo: {}
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"SETUSERNAME"]),
handleSelect(key, keyPath) {
console.log(key)
if(key=='5'){
window.open(this.url)
}
this.activeIndex = key
},
getData(){
var that = this
this.$Loading()
getUserInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
getKefuInfo({token: this.token}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.url = res.data
console.log(that.url )
}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/asset.vue